// extracted by mini-css-extract-plugin
module.exports = {"image":"_103e9d9","labelGroup":"_05cb098"};